import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M6 10.332a3.832 3.832 0 1 0 0-7.664 3.832 3.832 0 0 0 0 7.664Z",
      stroke: "currentColor",
      strokeWidth: 1.1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M4.952 5.451c0-.208.097-.408.269-.555a1 1 0 0 1 .647-.23h.262a1 1 0 0 1 .648.23.733.733 0 0 1 .269.555.785.785 0 0 1-.524.786.865.865 0 0 0-.393.407 1.32 1.32 0 0 0-.13.64M6 8.331v.004",
      stroke: "currentColor",
      strokeWidth: 1.1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgQuestion;